export const DEFAULT_COUNTRY = 'DE'
